import type { SVGProps } from "react";
const SvgClock02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m4.207 7.172-2.092-.127c1.5-3.958 5.804-6.212 10.001-5.091 4.47 1.194 7.126 5.764 5.931 10.207S12.26 19.24 7.79 18.046a8.36 8.36 0 0 1-6.122-6.81"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 6.667V10l1.667 1.667"
    />
  </svg>
);
export default SvgClock02;
